import { useState, useEffect } from "react";
import {
  TableContainer, Tr, Td, Th, Table, Thead, Tbody, Text, Icon, Button, Box, Heading,
  useToast, Input, Select, Popover, PopoverTrigger, Portal
  , PopoverContent, PopoverArrow, PopoverHeader, Checkbox, PopoverCloseButton, Stack,
  FormControl, FormLabel, PopoverFooter, PopoverBody, Spacer, Tooltip, Modal, ModalBody,
  ModalOverlay, ModalContent, ModalHeader, CloseButton, VStack, Badge
} from "@chakra-ui/react";
import { MdArrowBack, MdArrowForward, MdSearch, MdRestartAlt, MdOutlineHome } from "react-icons/md";
import { react_api } from "../config";
import { HTTP_STATUS_CODES } from "../GrinsCostant";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { EditIcon, InfoIcon, SearchIcon } from '@chakra-ui/icons';
import createAxiosInstance from "../interceptors/useAxiosInterceptors"
import { useSession } from '../SessionContext';
import logout from "../services/authService";
import { convertUtcToLocal } from "../services/utils";


function DatasetGuest() {
  const { t } = useTranslation();
  const [catalogCopy, setCatalogCopy] = useState([]);
  const navigate = useNavigate();
  const categories = [
    'Agricoltura, pesca, silvicoltura e prodotti alimentari',
    'Economia e finanza',
    'Istruzione, cultura e sport',
    'Energia',
    'Ambiente',
    'Governo e settore pubblico',
    'Salute',
    'Tematiche internazionali',
    'Giustizia, sistema giuridico e sicurezza pubblica',
    'Regioni e città',
    'Popolazione e società',
    'Scienza e tecnologia',
    'Trasporti'
  ];

  // Materiale Chiamata API -> Metadata
  const [metadataDescription, setMetadataDescription] = useState([]);
  const [isMetadataDescModalOpen, setMetadataDescModalOpen] = useState(false);
  const [metadata, setMetadata] = useState();
  const [metadataTableName, setMetadataTableName] = useState("");
  const [datasetTableName, setDatasetTableName] = useState("");
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [isMetadataModalOpen, setMetadataModalOpen] = useState(false);
  const [id, setTableId] = useState();
  const [scrollBehavior, setScrollBehavior] = useState('inside')
  
  const openMetadataDescriptionModal = async () => {
    try {
      const res = await getTableCol(id);
      if (res && res.columns) {
        setMetadataDescription(res.columns);  // Update state
        setMetadataDescModalOpen(true);       // Open modal
      } else {
        throw new Error("Invalid response or missing columns data");
      }
    } catch (error) {
      console.error("Error fetching column descriptions:", error);
      toast({
        title: t('toastMsg.callError'),
        description: t('catalog.dataset.modal.columnDescriptionError'),
        status: 'warning',
        duration: 4000,
        isClosable: true,
      });
    }
  };

  const openMetadataModal = (response, tableName) => {
    setDatasetTableName(tableName);
    setMetadata(response);
    setMetadataTableName(tableName);
    setSpinnerLoading(false);
    setMetadataModalOpen(true);
  };

  const closeMetadataModal = () => {
    setMetadataModalOpen(false);
  };

  //INIZIO getTableCol - CUSTOM
  const getTableCol = async (id) => {
    try {
      const urlFetch = `${react_api}/stagingAreaResult/getTableColADP`;
      const response = await fetch(urlFetch, {
        method: 'POST', // Ensure it's the correct method if API requires `POST`
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tableId: id }),
      });

      if (!response.ok) {
        return null;
      }

      const result = await response.json();
      return result || null;
    } catch (error) {
      console.error("Error in getTableCol:", error);
      return null;
    }
  };

  const axiosInstance = createAxiosInstance(async (axiosInstance) => {
    console.error("API request failed");
  });
  const visualizzaMetadati = async (id, tableName) => {
    setTableId(id);
    try {
      setSpinnerLoading(true)
      const options = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
      const urlFetch = `${react_api}/getMetadataADP/${id}`;
      // const response = await axiosInstance.get(urlFetch, options);
      const response = await fetch(urlFetch, options);
      const result = await response.json();
      if (response.status.toString() === HTTP_STATUS_CODES.OK) {
        openMetadataModal(result, tableName);
      } else {
        throw new Error(t('catalog.dataset.throwNewError.dataRecoveryError'));
      }

    } catch (error) {
      setSpinnerLoading(false);
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }
  };


  //FINE CUSTOM API




  // Fine Materiale Chiamata API -> Metadata

  const [searchDescriptionInput, setSearchDescriptionInput] = useState("");
  const [searchSelectedValue, setSearchSelectedValue] = useState('name');
  const [allChecked, setAllChecked] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [catalog, setCatalog] = useState([]);
  const toast = useToast();
  const [searchNameInput, setSearchNameInput] = useState("");
  const [searchTitleInput, setSearchTitleInput] = useState("");
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= Math.ceil(catalog.length / itemsPerPage)) {
      setCurrentPage(newPage);
    }
  };
  const handleSelectSearchChange = (event) => {
    setSearchSelectedValue(event.target.value);
  };
  const handleSearchDescriptionInput = (event) => {
    setSearchDescriptionInput(event.target.value);
  };

  const [searchCheckedCategories, setSearchCheckedCategories] =
    useState(Array(categories.length).fill(false))

  const handleCategoryChange = (index) => (e) => {
    const updatedCheckedCategories = [...searchCheckedCategories];
    updatedCheckedCategories[index] = e.target.checked;
    setSearchCheckedCategories(updatedCheckedCategories);
  };

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setSearchCheckedCategories(Array(categories.length).fill(isChecked));
    setAllChecked(isChecked);
    setIsIndeterminate(false);
  };

  const handleSearchNameInput = (event) => {
    setSearchNameInput(event.target.value);
  };

  const handleSearchTitleInput = (event) => {
    setSearchTitleInput(event.target.value);
  };
  useEffect(() => {
    const allChecked = searchCheckedCategories.every(Boolean);
    const someChecked = searchCheckedCategories.some(Boolean);
    setAllChecked(allChecked);
    setIsIndeterminate(!allChecked && someChecked);

    //Custom

    const fetchCatalog = async () => {
      try {

        const options = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },

        }
        const urlFetch = `${react_api}/guestDataset/getDatasetCatalogADP`;
        const response = await fetch(urlFetch, options);

        const result = await response.json();

        if (result.status === HTTP_STATUS_CODES.OK) {
          setCatalog(result.catalogues);
          setCatalogCopy(result.catalogues)
        }
      } catch (error) {
        toast({
          title: t('toastMsg.callError'),
          description: String(error),
          position: "top",
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
      }
    };
    fetchCatalog();
  }, [searchCheckedCategories, metadata]);

  const applyFilterDataset = () => {
    function updatePaginatedDate() {
      setCurrentPage(1)

      paginatedData = catalogFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
      totalPages = Math.ceil(catalogFiltered.length / itemsPerPage);

    }
    let catalogFiltered = catalogCopy
    if (searchCheckedCategories != null && searchCheckedCategories.length > 0) {

      let categoriesFilter = []
      searchCheckedCategories.forEach((value, index) => {
        if (value)
          categoriesFilter.push(categories[index])
      });
      if (categoriesFilter != null && categoriesFilter.length > 0) {

        catalogFiltered = catalogFiltered.filter(pageData =>
          pageData.categories.length > 0 && pageData.categories.some(cat => categoriesFilter.includes(cat))
        );
        updatePaginatedDate()
      }
    }
    if (searchTitleInput != null && searchTitleInput.length > 0) {
      catalogFiltered = catalogFiltered.filter(pageData => pageData.title != null).filter(pageData => pageData.title.toLowerCase() === searchTitleInput.toLowerCase() || pageData.title.toLowerCase().includes(searchTitleInput.toLowerCase()))
      updatePaginatedDate()
    }
    if (searchNameInput != null && searchNameInput.length > 0) {
      catalogFiltered = catalogFiltered.filter(pageData => pageData.tableName.toLowerCase() === searchNameInput.toLowerCase() || pageData.tableName.toLowerCase().includes(searchNameInput.toLowerCase()))
      updatePaginatedDate()
    }
    if (searchDescriptionInput != null && searchDescriptionInput.length > 0) {
      catalogFiltered = catalogFiltered.filter(pageData => pageData.description.toLowerCase() === searchDescriptionInput.toLowerCase() || pageData.description.toLowerCase().includes(searchDescriptionInput.toLowerCase()))
      updatePaginatedDate()
    }
    setCatalog(catalogFiltered)
  };
  const resetFilterDataset = () => {
    setCatalog(catalogCopy)
    setCurrentPage(1)
    paginatedData = catalog.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    totalPages = Math.ceil(catalog.length / itemsPerPage);
    setSearchCheckedCategories(Array(categories.length).fill(false))
    setSearchDescriptionInput("")
    setSearchTitleInput("")
    setSearchNameInput("")
    setSearchSelectedValue("name")

  }

  var paginatedData = catalog.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  var totalPages = Math.ceil(catalog.length / itemsPerPage);
  const startIndex = currentPage * itemsPerPage - 9;
  const endIndex = Math.min((currentPage) * itemsPerPage, catalog.length);
  return (
    <>
      <Box alignItems={"center"} justifyContent={"space-between"} display={"flex"} color={"rgba(11,78,90,255)"} bgColor={"#f6f3ec"}>
        <Heading>Datasets</Heading>

        {/* Previous Page Button with Tooltip */}
        <Tooltip label={t('toolTip.tooltipDataset.datasetHeader.previousPage')} placement="right">
          <Button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} bg={"#f6f3ec"}>
            <MdArrowBack />
          </Button>
        </Tooltip>

        {/* Page Info and Dataset Text */}
        <Box>
          {t('catalog.dataset.page')} {currentPage}/{totalPages}
          <Spacer />
          Dataset {startIndex} - {endIndex} {t('catalog.dataset.of')} {catalog.length}
        </Box>

        {/* Next Page Button with Tooltip */}
        <Tooltip label={t('toolTip.tooltipDataset.datasetHeader.nextPage')} placement="left">
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage * itemsPerPage >= catalog.length}
            bg={"#f6f3ec"}
          >
            <MdArrowForward />
          </Button>
        </Tooltip>

        {/* Home and Search Buttons */}
        <Box>
          <Tooltip label="Go back to Homepage" placement="bottom" closeOnClick={true}>
            <Button
              color={"rgba(11,78,90,255)"} bgColor={"#f6f3ec"} h={"100%"}
              onClick={() => navigate("/home")}
              leftIcon={<Icon as={MdOutlineHome} />}
            >
              Home
            </Button>
          </Tooltip>

          <Popover>
            <PopoverTrigger>
              <Button color={"rgba(11,78,90,255)"} bgColor={"#f6f3ec"} h={"100%"}>
                <Tooltip label={t('toolTip.tooltipDataset.datasetHeader.searchDataset')} placement="bottom" closeOnClick={true}>
                  <span style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    <Icon as={MdSearch} />
                    {t('catalog.dataset.search')}
                  </span>
                </Tooltip>
              </Button>
            </PopoverTrigger>

            <Portal>
              <PopoverContent bgColor={"white"} borderWidth={2} width={"100%"} borderColor={"#0888BE"}>
                <PopoverHeader color={"rgba(11,78,90,255)"} fontSize='lg' fontWeight='semibold'>{t('catalog.dataset.modal.searchTable')}</PopoverHeader>
                <PopoverBody>
                  <Stack spacing='4'>
                    <Box>
                      <FormControl>
                        <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('catalog.dataset.modal.category')}:</FormLabel>
                        <Select value={searchSelectedValue} onChange={handleSelectSearchChange} variant="filled">
                          <option value='name' variant="filled" defaultChecked>{t('catalog.dataset.modal.name')}</option>
                          <option value='title' variant="filled">{t('catalog.dataset.modal.title')}</option>
                          <option value='category' variant="filled">{t('catalog.dataset.modal.category')}</option>
                          <option value='description' variant="filled">{t('catalog.dataset.modal.description')}</option>
                        </Select>
                      </FormControl>
                    </Box>

                    <Box>
                      {searchSelectedValue === "visibility" ? (
                        ""
                      ) : searchSelectedValue === "category" ? (
                        <Box>
                          <Checkbox isChecked={allChecked} isIndeterminate={isIndeterminate} onChange={handleSelectAllChange}>
                            {t('catalog.dataset.modal.selectDeselectAll')}
                          </Checkbox>
                          <Stack pl={6} mt={1} spacing={1}>
                            {categories.map((category, index) => (
                              <Checkbox isChecked={searchCheckedCategories[index]} onChange={handleCategoryChange(index)}>
                                {category}
                              </Checkbox>
                            ))}
                          </Stack>
                        </Box>
                      ) : searchSelectedValue === "description" ? (
                        <Box>
                          <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('catalog.dataset.modal.enterDescription')}:</FormLabel>
                          <Input variant='filled' placeholder='value' name='valueForSearch' type='text' bg='white' value={searchDescriptionInput} onChange={handleSearchDescriptionInput} />
                        </Box>
                      ) : searchSelectedValue === "name" ? (
                        <Box>
                          <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('catalog.dataset.modal.enterDatasetName')}:</FormLabel>
                          <Input variant='filled' placeholder='value' name='valueForSearch' type='text' bg='white' value={searchNameInput} onChange={handleSearchNameInput} />
                        </Box>
                      ) : (
                        <Box>
                          <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('catalog.dataset.modal.enterDatasetTitle')}:</FormLabel>
                          <Input variant='filled' placeholder='value' name='valueForSearch' type='text' bg='white' value={searchTitleInput} onChange={handleSearchTitleInput} />
                        </Box>
                      )}
                    </Box>
                  </Stack>
                </PopoverBody>
                <PopoverFooter display="flex" justifyContent="space-between" alignItems="center" gap={4}>
                  <Button colorScheme='green' onClick={applyFilterDataset}>
                    <Icon as={MdSearch} />
                    {t('catalog.dataset.search')}
                  </Button>
                  <Button ml={4} leftIcon={<Icon as={MdRestartAlt} fontSize="2xl" />} colorScheme="teal" variant="solid" onClick={resetFilterDataset}>
                    Reset
                  </Button>
                </PopoverFooter>
              </PopoverContent>
            </Portal>
          </Popover>
        </Box>
      </Box>

      <Box overflowY="auto" direction="column" h="100%" w="100%" boxShadow="lg">
        <TableContainer px={"1%"} paddingTop={"1%"}>
          <Table variant='striped' w="100%">
            <Thead bgColor={"#0888BE"} position="sticky" top="0">
              <Tr>
                <Th align="left" w={"25%"} color={"white"}>Dataset</Th>
                {/* <Th color={"white"} w={"20%"} whiteSpace={"normal"} wordBreak={"break-word"}>{t('catalog.dataset.table.title')}</Th> */}
                <Th color={"white"} w={"40%"} whiteSpace={"normal"} wordBreak={"break-word"}>{t('catalog.dataset.table.description')}</Th>
                <Th color={"white"} w={"25%"} whiteSpace={"normal"} wordBreak={"break-word"}>{t('catalog.dataset.table.categories')}</Th>
                <Th color={"white"} w={"10%"} whiteSpace={"normal"} wordBreak={"break-word"}>Actions</Th>

              </Tr>
            </Thead>
            <Tbody>
              {catalog && paginatedData ? (
                paginatedData.map((item, index) => (
                  <Tr key={index}>
                    <Td whiteSpace={"normal"} wordBreak={"break-word"}>{item.tableName}</Td>
                    <Td whiteSpace={"normal"} wordBreak={"break-word"}>{item.description}</Td>
                    <Td>
                      <VStack spacing={2} wrap="wrap" align="start">
                        {Array.isArray(item.categories) ? (
                          item.categories.map((cat, idx) => (
                            <Tooltip key={idx} label={cat} hasArrow>
                              <Badge
                                color="black"
                                border="1px solid #0888BE"
                                bg="transparent"
                                borderRadius="md"
                                px={1}
                                py={0}
                                maxW="150px"
                                overflow="hidden"
                                textOverflow="ellipsis"
                                whiteSpace="nowrap"
                                display="inline-block"
                              >
                                {cat}
                              </Badge>
                            </Tooltip>
                          ))
                        ) : (
                          <Text>No categories available</Text>
                        )}
                      </VStack>
                    </Td>

                    <Td whiteSpace={"normal"} wordBreak={"break-word"}>
                      <Box ml={4} width="100%">
                        <Icon
                          as={InfoIcon}
                          boxSize={6}
                          onClick={() => visualizzaMetadati(item.id, item.tableName)}
                          _hover={{ color: "blue.200" }}
                        />
                      </Box>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="5" textAlign="center">
                    No data available
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>

      {/* INIZIO METADATA */}
      <Modal onClose={closeMetadataModal} isOpen={isMetadataModalOpen} isCentered scrollBehavior={scrollBehavior} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent maxW="60%" h="80%">
          <ModalHeader bgColor={"#0888BE"} color="yellowgreen" display="flex" justifyContent="space-between"><Box>Dataset metadata {t('catalog.dataset.modal.table.view')}: <Text fontSize={"lg"} fontWeight={"bold"} color="white">{metadataTableName}</Text>
          </Box>
            <Box display="flex" alignItems="center" gap={2}>
              <Button onClick={openMetadataDescriptionModal} size="sm">{t('catalog.dataset.modal.columnDescriptionButton')}</Button>
              <CloseButton onClick={closeMetadataModal} />
            </Box>
          </ModalHeader>
          {metadata ? (

            <ModalBody>
              <Box overflowY="auto" >
                <Table size="sm" variant='striped' w={"100%"} h={"100%"}>
                  <Thead fontFamily={"-moz-initial"} bg={"#0888BE"} position="sticky" top="0" zIndex={1}>
                    <Tr>
                      <Th color={"black"}>Dataset id</Th>
                      <Th color={"black"}>{t('catalog.dataset.modal.table.datasetTitle')}</Th>
                      <Th color={"black"}>{t('catalog.dataset.modal.table.tableName')}</Th>
                      <Th color={"black"}>{t('catalog.dataset.modal.table.rawFileName')}</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>

                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.dataset_id == null ? ("-") : (metadata.dataset_id)}</Td>

                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.title == null ? ("-") : (metadata.title)}</Td>

                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.table_name == null ? ("-") : (metadata.table_name)}</Td>

                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.file_name == null ? ("-") : (metadata.file_name)}</Td>
                    </Tr>
                  </Tbody>

                </Table> <br />
                <Table size="sm" variant='striped' w={"100%"} h={"100%"}>
                  <Thead fontFamily={"-moz-initial"} bg={"#0888BE"} position="sticky" top="0" zIndex={1}>
                    <Tr>
                      <Th color={"black"}>{t('catalog.dataset.modal.table.dataManager')}</Th>
                      <Th color={"black"}>{t('catalog.dataset.modal.table.contactProvider')}</Th>
                      <Th color={"black"}>{t('catalog.dataset.modal.table.owner')}</Th>
                      <Th color={"black"}>{t('catalog.dataset.modal.table.publisher')}</Th>

                    </Tr>
                  </Thead><Tbody>
                    <Tr>

                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.data_manager == null ? ("-") : (metadata.data_manager)}</Td>

                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.contactProvider == null ? ("-") : (metadata.contactProvider)}</Td>

                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.owner == null ? ("-") : (metadata.owner)}</Td>

                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.publisher == null ? ("-") : (metadata.publisher)}</Td>

                    </Tr> </Tbody>

                </Table> <br />

                <Table size="sm" variant='striped' w={"100%"} h={"100%"}><Thead fontFamily={"-moz-initial"} bg={"#0888BE"}><Tr><Th color={"black"}>{t('catalog.dataset.modal.table.description')}</Th></Tr></Thead>
                  <Tbody><Tr><Td>{metadata.description}</Td></Tr></Tbody></Table><br />

                <Table size="sm" variant='striped' w={"100%"} h={"100%"}>
                  <Thead fontFamily={"-moz-initial"} bg={"#0888BE"} position="sticky" top="0" zIndex={1}>
                    <Tr>
                      <Th color={"black"} >{t('catalog.dataset.modal.table.releaseDate')}</Th>
                      <Th color={"black"} >{t('catalog.dataset.modal.table.creationDate')}</Th>
                      <Th color={"black"} >{t('catalog.dataset.modal.table.lastModifiedDate')}</Th>

                    </Tr></Thead><Tbody>
                    <Tr>
                      <Td whiteSpace={"normal"} wordBreak={"break-word"} >{metadata.release_date == null ? ("-") : (convertUtcToLocal(metadata.release_date))}</Td>

                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.creation_date == null ? ("-") : (metadata.creation_date)}</Td>

                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.last_modified_date == null ? ("-") : (convertUtcToLocal(metadata.last_modified_date))}</Td>

                    </Tr></Tbody></Table>
                <br />
                <Table size="sm" variant='striped' w={"100%"} h={"100%"}>
                  <Thead fontFamily={"-moz-initial"} bg={"#0888BE"} >
                    <Tr>
                      <Th color={"black"}>{t('catalog.dataset.modal.table.field')}</Th>
                      <Th color={"black"}>{t('catalog.dataset.modal.table.value')}</Th>
                    </Tr>
                  </Thead><Tbody>
                    <Tr>
                      <Td color={"black"}>{t('catalog.dataset.modal.table.externalId')}</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.external_id == null ? ("-") : (metadata.external_id)}</Td>
                    </Tr>

                    <Tr>
                      <Td color={"black"}>{t('catalog.dataset.modal.table.internalVersion')}</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>
                        <Box display="flex" alignItems="center" gap="20px">
                          <Text>{metadata.current_version == null ? "-" : metadata.current_version}</Text>
                          <Text fontSize="sm" ml="50px">
                            {t('catalog.dataset.modal.table.dataUpdateDate')} : {metadata.external_update_date == null ? "-" : metadata.external_update_date}
                          </Text>
                        </Box>
                      </Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>{t('catalog.dataset.modal.table.externalVersion')}</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.external_version == null ? ("-") : (metadata.external_version)}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>Url</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.url == null ? ("-") : (metadata.url)}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>{t('catalog.dataset.modal.table.referencedId')}</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.versionOf == null ? ("-") : (metadata.versionOf)}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>{t('catalog.dataset.modal.table.visibility')}</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.visibility == null ? ("-") : (metadata.visibility)}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>{t('catalog.dataset.modal.table.encoding')}</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.encoding == null ? ("-") : (metadata.encoding)}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>{t('catalog.dataset.modal.table.isProcessed')}</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.prov_elab == null ? ("-") : (metadata.prov_elab)}</Td>
                    </Tr>
                    
                    <Tr>
                      <Td color={"black"} >{t('catalog.dataset.modal.table.licenseName')}</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.licence_name == null ? ("-") : (metadata.licence_name)}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>{t('catalog.dataset.modal.table.latitude')}</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.latitude == null ? ("-") : (metadata.latitude)}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>{t('catalog.dataset.modal.table.longitude')}</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.longitude == null ? ("-") : (metadata.longitude)}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>{t('catalog.dataset.modal.table.category')}</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.categories == null ? ("-") : (metadata.categories.toString())}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>Data Frequency</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.data_frequency == null ? ("-") : (metadata.data_frequency.toString())}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>Typology Source</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.typology_source == null ? ("-") : (metadata.typology_source.toString())}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>Aggregation Level</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.level_aggregation == null ? ("-") : (metadata.level_aggregation.toString())}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>Geographical Coverage</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.geographical_coverage == null ? ("-") : (metadata.geographical_coverage.toString())}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>Record Identifier</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.record_identifier == null ? ("-") : (metadata.record_identifier.toString())}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>ID - Validation Metadata ML</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.id_validation_metadataml == null ? ("-") : (metadata.id_validation_metadataml.toString())}</Td>

                    </Tr>
                  </Tbody>

                </Table></Box> </ModalBody>) : null}
        </ModalContent>
      </Modal>
      {/* INIZIO Col Description */}
      <Modal isOpen={isMetadataDescModalOpen} isCentered size="lg" scrollBehavior="inside" closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent maxW="40%" h="60%" position="absolute" top="35%" transform="translateY(-50%)">
          <ModalHeader bgColor="#0888BE" color="yellowgreen" display="flex" justifyContent="space-between">
            <Box>
              Dataset: <Text fontSize="lg" fontWeight="bold" color="white">{datasetTableName}</Text>
            </Box>
            <Box>
              <CloseButton onClick={() => setMetadataDescModalOpen(false)} />
            </Box>
          </ModalHeader>
          <ModalBody tabIndex={0} overflowY="auto" maxH="calc(100vh - 200px)" onWheel={(e) => e.stopPropagation()}>
            <Table size="sm" variant="striped" w="100%">
              <Thead bgColor="#0888BE">
                <Tr>
                  <Th color="white">{t('catalog.dataset.modal.columnName')}</Th>
                  <Th color="white">{t('catalog.dataset.modal.columnType')}</Th>
                  <Th color="white">{t('catalog.dataset.modal.columnDescription')}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {metadataDescription.length > 0 ? (
                  metadataDescription.map((item, index) => (
                    <Tr key={index}>
                      <Td>{item.name}</Td>
                      <Td>{item.type}</Td>
                      <Td>{item.fielddescription}</Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan="3">No data available</Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* FINE METADATA */}

    </>




  );
}

export default DatasetGuest;
